module.exports = __webpack_public_path__ + "assets/GoldUpsilon2x.a3f2e7da4c1f6778790dee4f3a64885a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldUpsilon2x.png
// module id = 825
// module chunks = 0